export default __webpack_public_path__ + "static/launceston-card-35fc0e9497894177b709ec94160ec8a1.jpg";